import { GenericDataType } from 'modules/domains';
import { useMappingsByDataType } from 'api/MappingsAPI';
import { RestQueryHookResult } from 'utils/hooks/api/useRestQuery';
import { sortObjectListByKey } from 'utils/arrayHelpers';
import { HookData, NewEndpointQueryResponse } from './types';
import { getContactProperty } from './utils';

export const useNewEndpoint = (): Omit<RestQueryHookResult<NewEndpointQueryResponse>, 'data'> & {
  data: HookData;
} => {
  const { data = [], ...response } = useMappingsByDataType(GenericDataType.User);
  const contactProperties = data.map(getContactProperty);
  const sortedByNameProperties = sortObjectListByKey(contactProperties, 'name');

  return {
    ...response,
    data: sortedByNameProperties,
  };
};
